import React from 'react';
import Add from '@mui/icons-material//Add';
import { Divider, MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';
import { NEW_FIRM_SLUG } from 'common/constants/sidebar';
import { AddFirmItemProps } from './AddFirmItem.props';

const AddFirmItem = ({ handleAddFirm, classes }: AddFirmItemProps) => (
  <div key={NEW_FIRM_SLUG}>
    <Divider className={classes?.divider} />
    <Link to="#">
      <MenuItem
        key={NEW_FIRM_SLUG}
        onClick={handleAddFirm}
        className={`
              sidebar-bottom__dropdown-item
              sidebar-bottom__dropdown-item-${NEW_FIRM_SLUG}
              ${classes?.menuItem}
          `}>
        <Add className={classes?.menuItemIcon} />
        Add Firm
      </MenuItem>
    </Link>
  </div>
);

export default AddFirmItem;
